import { DraggableMenuInfoModel } from '../../common/components/draggable-checkbox-menu/draggable-menu-info.model';

export const customizableColumnsMenuInfo: DraggableMenuInfoModel = {
  titleText: 'Customize',
  headerText: 'Customize columns',
  headerDescription: 'Use checkboxes, drag & drop to customize the table columns.'
};
